import React, { useEffect, useState } from 'react';
import { FaDiscord, FaPlay, FaCrown, FaDownload } from 'react-icons/fa';
import Navbar from '../../components/Navbar/Navbar';
import ServerStatus from '../../components/ServerStatus/ServerStatus';
import { fetchSiteConfig, DEFAULT_SITE_CONFIG } from '../../services/siteConfigService';
import './Home.css';

const Home = () => {
  const [config, setConfig] = useState(DEFAULT_SITE_CONFIG);

  useEffect(() => {
    let alive = true;
    fetchSiteConfig().then((cfg) => {
      if (alive) setConfig(cfg);
    });

    const onUpdate = (event) => {
      if (event.detail) setConfig(event.detail);
    };
    window.addEventListener('nexus:site-config', onUpdate);

    return () => {
      alive = false;
      window.removeEventListener('nexus:site-config', onUpdate);
    };
  }, []);

  const sections = config.sections || DEFAULT_SITE_CONFIG.sections;
  const pages = config.pages || DEFAULT_SITE_CONFIG.pages;

  return (
    <div className="home">
      <Navbar />

      <section className="home-hero">
        <div className="home-hero__scene" aria-hidden="true">
          <div className="home-hero__sky" />
          <div className="home-hero__mist" />
          <svg className="home-hero__terrain" viewBox="0 0 1440 520" preserveAspectRatio="xMidYMax slice">
            <defs>
              <linearGradient id="hillFar" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2a1a4a" />
                <stop offset="100%" stopColor="#180f2e" />
              </linearGradient>
              <linearGradient id="hillNear" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#4c2d8a" />
                <stop offset="55%" stopColor="#2f1a5c" />
                <stop offset="100%" stopColor="#160e2c" />
              </linearGradient>
            </defs>
            <path fill="url(#hillFar)" d="M0 320 L120 280 L240 300 L360 240 L480 270 L600 210 L720 250 L840 200 L960 240 L1080 190 L1200 230 L1320 210 L1440 240 L1440 520 L0 520 Z" />
            <g fill="#24163f">
              <rect x="180" y="220" width="28" height="90" />
              <rect x="166" y="200" width="56" height="36" />
              <rect x="174" y="176" width="40" height="32" />
              <rect x="900" y="170" width="32" height="100" />
              <rect x="884" y="148" width="64" height="40" />
              <rect x="892" y="120" width="48" height="36" />
              <rect x="1180" y="190" width="24" height="80" />
              <rect x="1168" y="170" width="48" height="32" />
            </g>
            <path fill="url(#hillNear)" d="M0 380 L160 340 L280 360 L400 310 L560 350 L700 300 L860 340 L1000 290 L1160 330 L1300 300 L1440 340 L1440 520 L0 520 Z" />
            <g fill="#3d2a1a">
              <rect x="620" y="250" width="36" height="120" />
              <rect x="596" y="220" width="84" height="48" />
              <rect x="608" y="188" width="60" height="44" />
              <rect x="620" y="160" width="36" height="36" />
            </g>
            <g fill="#7c3aed">
              <rect x="596" y="220" width="84" height="20" />
              <rect x="608" y="188" width="60" height="20" />
              <rect x="620" y="160" width="36" height="16" />
            </g>
            <rect x="0" y="460" width="1440" height="60" fill="#120a1c" />
            <g fill="#1e1430" opacity="0.9">
              <rect x="0" y="460" width="80" height="20" />
              <rect x="80" y="480" width="80" height="20" />
              <rect x="160" y="460" width="80" height="20" />
              <rect x="240" y="480" width="80" height="20" />
              <rect x="320" y="460" width="80" height="20" />
              <rect x="400" y="480" width="80" height="20" />
              <rect x="480" y="460" width="80" height="20" />
              <rect x="560" y="480" width="80" height="20" />
              <rect x="640" y="460" width="80" height="20" />
              <rect x="720" y="480" width="80" height="20" />
              <rect x="800" y="460" width="80" height="20" />
              <rect x="880" y="480" width="80" height="20" />
              <rect x="960" y="460" width="80" height="20" />
              <rect x="1040" y="480" width="80" height="20" />
              <rect x="1120" y="460" width="80" height="20" />
              <rect x="1200" y="480" width="80" height="20" />
              <rect x="1280" y="460" width="80" height="20" />
              <rect x="1360" y="480" width="80" height="20" />
            </g>
          </svg>
          <div className="home-hero__grid" />
        </div>

        <div className="home-hero__content">
          <h1 className="home-hero__brand">NEXUS</h1>
          <p className="home-hero__title">Sobreviva. Construa. Domine.</p>
          <p className="home-hero__lead">
            Vanilla com plugins certeiros — economia, clãs e eventos numa comunidade que joga sério.
          </p>

          {sections.serverStatus && <ServerStatus variant="hero" />}

          <div className="home-hero__actions">
            {pages.download ? (
              <a href="/download" className="home-btn home-btn--primary">
                <FaDownload />
                Baixar Launcher
              </a>
            ) : (
              <a
                href="https://discord.gg/9W4Vusc4m2"
                target="_blank"
                rel="noopener noreferrer"
                className="home-btn home-btn--primary"
              >
                <FaDiscord />
                Entrar no Discord
              </a>
            )}
            {pages.download ? (
              <a
                href="https://discord.gg/9W4Vusc4m2"
                target="_blank"
                rel="noopener noreferrer"
                className="home-btn home-btn--ghost"
              >
                <FaDiscord />
                Discord
              </a>
            ) : null}
            {sections.homeJoin && (
              <a href="#como-entrar" className="home-btn home-btn--ghost">
                <FaPlay />
                Como entrar
              </a>
            )}
          </div>
        </div>
      </section>

      {sections.homeWorld && (
        <section className="home-world">
          <div className="home-wrap">
            <header className="home-world__intro">
              <h2>Um mundo feito pra durar</h2>
              <p>Infraestrutura estável, systems que importam e zero enrolação.</p>
            </header>

            <ul className="home-world__list">
              <li className="home-world__item">
                <span className="home-world__mark" aria-hidden="true" />
                <div>
                  <h3>Servidor estável</h3>
                  <p>Baixa latência e uptime constante pra você focar no que importa: jogar.</p>
                </div>
              </li>
              <li className="home-world__item">
                <span className="home-world__mark home-world__mark--gold" aria-hidden="true" />
                <div>
                  <h3>Economia viva</h3>
                  <p>Lojas, mercado e rotas reais de progressão — sem inflate caótico.</p>
                </div>
              </li>
              <li className="home-world__item">
                <span className="home-world__mark home-world__mark--teal" aria-hidden="true" />
                <div>
                  <h3>Clãs e território</h3>
                  <p>Reúna aliados, proteja o que é seu e dispute o mapa com estratégia.</p>
                </div>
              </li>
              <li className="home-world__item">
                <span className="home-world__mark home-world__mark--amber" aria-hidden="true" />
                <div>
                  <h3>Eventos semanais</h3>
                  <p>Competições e recompensas exclusivas pra manter o servidor sempre quente.</p>
                </div>
              </li>
            </ul>
          </div>
        </section>
      )}

      {sections.homeJoin && (
        <section id="como-entrar" className="home-join">
          <div className="home-wrap home-join__grid">
            <div className="home-join__copy">
              <h2>Como entrar</h2>
              <p>Quatro passos. Em poucos minutos você já está no servidor.</p>

              {sections.serverStatus && <ServerStatus variant="panel" />}
              <p className="home-join__note">Confirme o IP oficial no Discord — ele pode ser atualizado.</p>
            </div>

            <ol className="home-join__steps">
              <li>
                <span>01</span>
                <div>
                  <h3>Entre no Discord</h3>
                  <p>Pegue regras, IP oficial e fale com a staff.</p>
                </div>
              </li>
              <li>
                <span>02</span>
                <div>
                  <h3>{pages.download ? 'Baixe o Nexus Client' : 'Abra o Minecraft'}</h3>
                  <p>
                    {pages.download
                      ? 'Instale o launcher oficial e entre com Microsoft ou offline.'
                      : 'Java Edition 1.20.x ou superior.'}
                  </p>
                </div>
              </li>
              <li>
                <span>03</span>
                <div>
                  <h3>{pages.download ? 'Clique em Jogar' : 'Adicione o servidor'}</h3>
                  <p>
                    {pages.download
                      ? 'O Client instala o Java se precisar e conecta no Origins.'
                      : 'Cole o IP na lista multiplayer e salve.'}
                  </p>
                </div>
              </li>
              <li>
                <span>04</span>
                <div>
                  <h3>Entre e jogue</h3>
                  <p>Explore, construa e encontre sua galera.</p>
                </div>
              </li>
            </ol>
          </div>
        </section>
      )}

      {sections.homeCta && (
        <section className="home-cta">
          <div className="home-wrap home-cta__inner">
            <h2>Pronto pra spawnar?</h2>
            <p>
              {pages.download
                ? 'Baixe o Nexus Client e começa sua temporada no servidor.'
                : 'Entra no Discord, pega o IP e começa sua temporada no Nexus.'}
            </p>
            <div className="home-cta__actions">
              {pages.download ? (
                <a href="/download" className="home-btn home-btn--primary home-btn--lg">
                  <FaDownload />
                  Baixar Launcher
                </a>
              ) : (
                <a
                  href="https://discord.gg/9W4Vusc4m2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-btn home-btn--primary home-btn--lg"
                >
                  <FaDiscord />
                  Entrar no Discord
                </a>
              )}
              {pages.vip && (
                <a href="/vip" className="home-btn home-btn--vip home-btn--lg">
                  <FaCrown />
                  Planos VIP
                </a>
              )}
            </div>
          </div>
        </section>
      )}

      <footer className="home-footer">
        <div className="home-wrap home-footer__top">
          <div className="home-footer__brand">
            <p className="home-footer__name">NEXUS</p>
            <p>Vanilla com plugins, economia, clãs e eventos. Comunidade em primeiro lugar.</p>
          </div>
          <div className="home-footer__cols">
            <div>
              <h4>Links</h4>
              <ul>
                {sections.homeJoin && <li><a href="#como-entrar">Como entrar</a></li>}
                {pages.download && <li><a href="/download">Download</a></li>}
                {pages.vip && <li><a href="/vip">Planos VIP</a></li>}
                {pages.team && <li><a href="/equipe">Equipe</a></li>}
                {pages.conta && <li><a href="/conta">Minha conta</a></li>}
                <li><a href="/termos">Termos de Serviço</a></li>
              </ul>
            </div>
            <div>
              <h4>Comunidade</h4>
              <ul>
                <li>
                  <a href="https://discord.gg/9W4Vusc4m2" target="_blank" rel="noopener noreferrer">
                    Discord
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="home-footer__bottom">
          <p>© 2026 Vih's Studio. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
